// 23:"content-management.news-management.newsletter.find"
// 24:"content-management.news-management.newsletter.create"
// 25:"content-management.news-management.newsletter.update"
// 26:"content-management.news-management.newsletter.remove"
// 27:"content-management.news-management.publish.newsletter.update"
// 28:"content-management.news-management.newsletter.updateStatusToDraft"
// 29:"content-management.news-management.inactivate.newsletter.update"
// export const permissionsKeys = {
//   page: 'content-management.dynamic-page',
//   pageBlockFind: 'content-management.dynamic-page.find',
//   pageBlockPreview: 'content-management.dynamic-page.preview',
//   pageBlockCreate: 'content-management.dynamic-page.create',
//   pageBlockUpdate: 'content-management.dynamic-page.update',
//   pageBlockRemove: 'content-management.dynamic-page.remove',
//   pageBlockUpdatePublish: 'content-management.publish.dynamic-page.update',
//   pageBlockUpdateStatusToDraft: 'content-management.dynamic-page.updateStatusToDraft',
//   pageBlockUpdateInactivate: 'content-management.inactivate.dynamic-page.update',
// };
export const permissionsKeys = {
  page: 'content-management.news-management.newsletter',
  pageBlockFind: 'content-management.news-management.newsletter.find',
  pageBlockCreate: 'content-management.news-management.newsletter.create',
  pageBlockUpdate: 'content-management.news-management.newsletter.update',
  pageBlockRemove: 'content-management.news-management.newsletter.remove',
  pageBlockUpdatePublish: 'content-management.news-management.publish.newsletter.update',
  pageBlockUpdateStatusToDraft: 'content-management.news-management.newsletter.updateStatusToDraft',
  pageBlockUpdateInactivate: 'content-management.news-management.inactivate.newsletter.update',
} as const;
